import { supabase } from "../supabase/supabase";

interface IScore {
    game?: string;
    player?: number;
    score?: number;
}

export class Score {
    game: string;
    player: number;
    score: number;

    constructor(game: string, player: number, score: number) {
        this.game = game;
        this.player = player;
        this.score = score;
    }

    static fromJson(json: IScore) {
        return new Score(
            json.game ? json.game as string : "",
            json.player ? json.player as number : 0,
            json.score ? json.score as number : 0,
        );
    }

    static async addNewScore(gameId: string, playerId: number) {
        const { data, error } = await supabase
            .from("Scores")
            .insert({
                game: gameId,
                player: playerId,
                score: 0,
            });
    }

    static async updateScore(playerId: number, newScore: number) {
        const { error } = await supabase
            .from("Scores")
            .update({ score: newScore })
            .eq("player", playerId);
    }

    static async getScores(gameId: string) {
        const scores = [];
        const { data, error } = await supabase
            .from("Scores")
            .select(`
                player,
                score
                `)
            .eq("game", gameId);

        for (let idx = 0; idx < data!.length; idx++) {
            const score = this.fromJson(data![idx]);
            scores.push(score);
        }

        return scores;
    }
}